<div class="listbox-container">
  <div class="row mx-0">

    <!-- Left Panel: Available Fields -->
    <div class="col-6 pl-0 pr-2">
      <div class="listbox-panel">
        <div class="panel-header">
          <span class="panel-title">{{_headers[1]}}</span>
          <span class="count-badge">{{totalAvailableCount}}</span>
        </div>

        <div class="search-wrapper">
          <i class="far fa-search search-icon"></i>
          <input
            type="text"
            class="search-input"
            placeholder="Search fields..."
            [(ngModel)]="_searchText"
            (ngModelChange)="onSearch()"
          />
        </div>

        <div class="groups-list">
          @for (group of _filteredGroups; track group.parent) {
            <div class="group-section">
              <div class="group-header" (click)="toggleGroup(group)">
                <i class="group-chevron fas"
                   [class.fa-chevron-right]="!group.expanded && !_searchText"
                   [class.fa-chevron-down]="group.expanded || !!_searchText"></i>
                <span class="group-name">{{group.parent}}</span>
                <span class="group-count ml-1">({{group.availableFields.length}})</span>
                @if (group.availableFields.length > 0) {
                  <a class="add-all-btn" (click)="addGroup($event, group)">+All</a>
                }
              </div>
              @if (group.expanded || !!_searchText) {
                @for (field of group.availableFields; track field.id) {
                  <div class="field-row" (click)="addRemoveField(field.id, 'add')">
                    <i [class]="getTypeIcon(field.type) + ' type-icon'"></i>
                    <span class="field-label">{{field.label}}</span>
                    <button class="add-btn" (click)="addRemoveField(field.id, 'add'); $event.stopPropagation()">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                }
              }
            </div>
          }
          @if (_filteredGroups.length === 0 && _searchText) {
            <div class="empty-state">No fields match your search</div>
          }
          @if (_filteredGroups.length === 0 && !_searchText && totalAvailableCount === 0) {
            <div class="empty-state">All fields have been selected</div>
          }
        </div>
      </div>
    </div>

    <!-- Right Panel: Selected Columns -->
    <div class="col-6 pr-0 pl-2">
      <div class="listbox-panel">
        <div class="panel-header">
          <span class="panel-title">{{_headers[2]}}</span>
          <span class="count-badge">{{_selectedFields.length}}</span>
        </div>

        <div class="groups-list selected-list"
             [dndDropzone]="['field']"
             (dndDrop)="onDrop($event)">
          <div class="dndPlaceholder" dndPlaceholderRef></div>
          @if (_selectedFields.length === 0) {
            <div class="empty-state">Add fields from the left panel</div>
          }
          @for (field of _selectedFields; track field.id) {
            <div class="field-row selected-row"
                 [dndDraggable]="field"
                 dndType="field"
                 dndEffectAllowed="move">
              <i class="fak fa-drag drag-handle" dndHandle></i>
              <i [class]="getTypeIcon(field.type) + ' type-icon'"></i>
              <span class="field-label">{{field.label}}</span>
              <button class="remove-btn" (click)="addRemoveField(field.id, 'remove')">
                <i class="fas fa-times"></i>
              </button>
            </div>
          }
        </div>
      </div>
    </div>

  </div>
</div>
